import type { SectorData } from '@/types/telemetry';
import { useI18n } from '@/context/I18nContext';

interface SectorTabsProps {
  sectors: SectorData[];
  activeSector: number;
  onSectorChange: (index: number) => void;
}

function sectorHue(idx: number, total: number): number {
  return (idx * 360 / total) % 360;
}

export function SectorTabs({ sectors, activeSector, onSectorChange }: SectorTabsProps) {
  const { t } = useI18n();
  return (
    <div className="p-1 bg-bg-surface border border-border-subtle rounded-xl flex items-center gap-1 overflow-x-auto">
      {sectors.map((_, i) => {
        const hue = sectorHue(i, sectors.length);
        const active = i === activeSector;
        return (
          <button
            key={i}
            onClick={() => onSectorChange(i)}
            className={`flex-1 min-w-[120px] flex items-center justify-center gap-2 py-2 px-3 rounded-lg text-xs font-semibold transition-all duration-150 cursor-pointer ${
              active
                ? 'shadow-xs border'
                : 'text-text-secondary hover:text-text-primary hover:bg-bg-hover border border-transparent'
            }`}
            style={active ? {
              background: `hsla(${hue}, 70%, 55%, 0.15)`,
              color: `hsl(${hue}, 70%, 65%)`,
              borderColor: `hsla(${hue}, 70%, 55%, 0.3)`,
            } : undefined}
          >
            <span
              className="w-2 h-2 rounded-full transition-opacity"
              style={{
                backgroundColor: `hsl(${hue}, 70%, 55%)`,
                opacity: active ? 1 : 0.6,
              }}
            />
            <span>{t('sector.sectorN', { n: i + 1 })}</span>
          </button>
        );
      })}
    </div>
  );
}
